import { Component, input, output } from '@angular/core';

export type IdentificationCardVariant =
  | 'qr'
  | 'manual'
  | 'documents'
  | 'rdv'
  | 'no-rdv'
  | 'arrival'
  | 'departure';

@Component({
  selector: 'app-identification-card',
  standalone: true,
  templateUrl: './identification-card.component.html',
  styleUrl: './identification-card.component.scss',
})
export class IdentificationCardComponent {
  readonly variant = input.required<IdentificationCardVariant>();
  readonly title = input.required<string>();
  readonly subtitle = input.required<string>();
  readonly illustrationSrc = input.required<string>();
  readonly illustrationAlt = input('');

  readonly pressed = output<void>();

  onPress(): void {
    this.pressed.emit();
  }
}
